const EXPERIMENTAL_TILE_PRELOADING_VERSION = "0.1.0";

export { EXPERIMENTAL_TILE_PRELOADING_VERSION };
